// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__Vv3Ia","card":"_styles_card__LAMRk","card_info":"_styles_card_info__nmbkM","card_btn":"_styles_card_btn__sbJPN"};